import type { MangaItem } from '@/mocks/manga';

interface MangaCardProps {
  item: MangaItem;
  rank?: number;
}

export default function MangaCard({ item, rank }: MangaCardProps) {
  return (
    <article
      data-product-shop
      className="group flex flex-col overflow-hidden rounded-lg bg-background-100 border border-background-200/80 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title}漫画封面 好漫推荐`}
          title={`${item.title} · ${item.genre}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {rank !== undefined && (
          <span className="absolute left-3 top-3 flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50 text-sm font-bold shadow-card">
            {rank}
          </span>
        )}
        {item.badge && (
          <span className="absolute right-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-foreground-950">
            {item.badge}
          </span>
        )}
        <span className="absolute bottom-3 left-3 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs text-background-50 backdrop-blur-sm">
          {item.status}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex items-center justify-between gap-2">
          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900 whitespace-nowrap">
            {item.genre}
          </span>
          <span className="flex items-center gap-1 text-sm font-semibold text-accent-700 whitespace-nowrap">
            <i className="ri-star-fill text-accent-500" aria-hidden="true"></i>
            {item.rating.toFixed(1)}
          </span>
        </div>
        <h3 className="mt-3 font-heading text-lg text-foreground-950">{item.title}</h3>
        <p className="mt-1 text-sm text-foreground-600">{item.author} 著</p>
        <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {item.description}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-2 pt-4">
          <span className="flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
            <i className="ri-file-list-3-line" aria-hidden="true"></i>
            {item.chapters}话
          </span>
          <span className="flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
            <i className="ri-user-heart-line" aria-hidden="true"></i>
            {item.fans}追更
          </span>
        </div>
      </div>
    </article>
  );
}